export default "__VITE_ASSET__8_0Se9p3__"